// © ООО «Эдиспа», 2022

export const compact = (data: any): any => JSON.parse(JSON.stringify(data));

export const swap = (data: any, keyOne: string, keyTwo: string) => {
  const temp = data[keyOne];
  data[keyOne] = data[keyTwo];
  data[keyTwo] = temp;
};
